import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'virtual:uno.css';
import './index.css';
import App from './app';

const container = document.getElementById('root');
const root = createRoot(container!);

const renderApp = (): void => {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
};

if (process.env.NODE_ENV === 'development') {
  import('../mocks/browser').then(({ worker }) => {
    worker.start().then(() => {
      renderApp();
    });
  });
} else {
  renderApp();
}
